
import WebApps from '../../views/services/_webapps'
export default WebApps